"use strict";

import lang from "vwa/lang";
import api from "vwa/api";
import geocode from "vwa/geocode";
import dispatcher from "./../dispatcher";
import openedDetailsStore from "./../store/openedDetails";
import Toast from "vwa/components/Toast";
import {getUserId} from "./../utils/user";
import storeAddress from "./storeAddress";

import {
	getAddressFromUniqPositionMapByPosition,
	uniqPositionMapToUniqPositionSet,
	uniqPositionSetToUniqPositionMap,
	extendAddressPositionPairForUniqPositionMap
} from "./../utils/resolver";

export default async function getVehicleActivity(vehicleId, from, to, sectionLimit = 0.1) {
	
	try{
		dispatcher.dispatch("setPendingActivity", vehicleId, from, to);
		const reportResponse = await api.get("reports", {
			carrier: vehicleId,
			from,
			to,
			type: "VehicleActivity",
			user: getUserId(),
			sectionLimit
		});
		const details = openedDetailsStore.get(vehicleId);
		if (!details)
			return;
		const report = reportResponse.reports[0];
		await resolveAddresses(report.result);
		dispatcher.dispatch("getVehicleActivity", report, from, to);
	}
	catch(error){
		if("id" in error){
			new Toast(lang.OPERATION_FAILED, "orange");
		}
		else{
			throw error;
		}
	}
}

// CÍMFELOLDÁS

async function resolveAddresses(result) {
	const summary = result.summary;
	const activeSections = result.sections.filter(s => s.active);
	const uniqPositionSet = createUniqPositionSet(summary, activeSections);
	
	for (let item of uniqPositionSet) {
		if (item.address)
			continue;
		try {
			item.address = await geocode('nominatim', item.position);
			await storeAddress(item.position, item.address);
		} catch (error) {}
	}
	
	resolveUniqPositionSet(summary, activeSections, uniqPositionSet);
}

function createUniqPositionSet(summary, activeSections) {
	
	const posAddMap = {};

	extendAddressPositionPairForUniqPositionMap(posAddMap, summary.start.position ? summary.start.position.value : null, summary.start.address);
	extendAddressPositionPairForUniqPositionMap(posAddMap, summary.end.position ? summary.end.position.value : null, summary.end.address);
	
	activeSections.forEach(section => {
		extendAddressPositionPairForUniqPositionMap(posAddMap, section.start.position ? section.start.position.value : null, section.start.address);
		extendAddressPositionPairForUniqPositionMap(posAddMap, section.end.position ? section.end.position.value : null, section.end.address);
	});

	// creating set from map
	return uniqPositionMapToUniqPositionSet(posAddMap);

}

function resolveUniqPositionSet(summary, activeSections, uniqPositionSet) {
	
	const uniqPositionMap = uniqPositionSetToUniqPositionMap(uniqPositionSet);
	
	summary.start.address = getAddressFromUniqPositionMapByPosition(uniqPositionMap, summary.start.position ? summary.start.position.value : null);
	summary.end.address = getAddressFromUniqPositionMapByPosition(uniqPositionMap, summary.end.position ? summary.end.position.value : null);

	activeSections.forEach(section => {
		section.start.address = getAddressFromUniqPositionMapByPosition(uniqPositionMap, section.start.position ? section.start.position.value : null);
		section.end.address = getAddressFromUniqPositionMapByPosition(uniqPositionMap, section.end.position ? section.end.position.value : null);
	});

}


// WEBPACK FOOTER //
// ./src/api/getVehicleActivity.js